import { render, staticRenderFns } from "./Modalable.vue?vue&type=template&id=f06ec184&"
import script from "./Modalable.vue?vue&type=script&lang=js&"
export * from "./Modalable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports